import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import ActivityForm from './components/ActivityForm';
import LoginForm from './components/LoginForm';
import Admin from './components/Admin';
import ActivityList from './components/ActivityList';
import Colaboradores from './components/Colaboradores';
import history from './history';

const App = () => {
  return (
    <Router history={history}>
      <Routes>
        <Route path="/" element={<PublicRoute component={ActivityForm} />} />
        <Route path="/login" element={<PublicRoute component={LoginForm} />} />
        <Route path="/admin" element={<PrivateRoute component={Admin} />}>
          <Route path="activities" element={<ActivityList  />} />
          <Route path="colaboradores" element={<Colaboradores />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
